/// <reference path="../../bower_components/jquery/dist/jquery.js" />


function showImagesWhenVisible() {
    $('[data-src]').on('inview', function (event, isInView) {
        if (isInView) {
            var $this = $(this);
            $el = $(this);
            $el.attr('src', $el.data('src'));
            $el.removeData('src');
            $this.off('inview');
        }
    });
}


$(document).ready(function () {
        // From Navigation.js
        initializeNavigation();
        // From Site.js
        initializeGlobalElements();
        // From Search.js
        initializeSearch();
        // From SearchResults.js
        //initializeSearchResults();
        // From Listing.Map.js
        //startMapping();
        // From Listing.js
        //initializeListing();
        // From Enquiry.js
        //initializeEnquiryForm();
        // From Share.js
        //shareListingForm();
        // From MyBayleys.js
        initializeMyBayleys();
        // From News.js
        //loadMoreArticles();
        // From Piranha.js
        initializePiranhaElements();
        // From Auctions.js
        //initializeCalendar();
        // From MagazineSubscription.js
        //initializeMagazineSubscription();
        showImagesWhenVisible();
});
